import { User, Calendar, Award } from 'lucide-react';
import { defineSchema, CANONICAL_CATEGORIES } from '@shared/search';

export const driversListSchema = defineSchema({
  id: 'drivers-list',
  title: 'filter.schema.driversList.title',
  subtitle: 'filter.schema.driversList.subtitle',
  defaultField: 'name',
  fields: {
    name: {
      key: 'name',
      label: 'filter.field.driverName',
      type: 'text',
      icon: User,
      placeholder: 'filter.placeholder.driverName',
      description: 'filter.desc.driverName',
      example: 'name:Yanick',
    },
    season: {
      key: 'season',
      label: 'filter.field.season',
      type: 'number',
      icon: Calendar,
      description: 'filter.desc.season',
      example: 'season:2026',
      presets: [
        { label: '2026', value: '2026', operator: '=' },
        { label: '2025', value: '2025', operator: '=' },
        { label: '2024', value: '2024', operator: '=' },
      ],
    },
    category: {
      key: 'category',
      label: 'filter.field.category',
      type: 'enum',
      icon: Award,
      allowMultiple: true,
      description: 'filter.desc.category',
      options: CANONICAL_CATEGORIES,
      example: 'category:Max',
    },
    from: {
      key: 'from',
      label: 'filter.field.date',
      type: 'dateRange',
      icon: Calendar,
      description: 'filter.desc.date',
      example: 'from:-1y',
      datePresets: [
        { label: 'filter.preset.today', value: 'today' },
        { label: 'filter.preset.last30d', value: '-30d' },
        { label: 'filter.preset.last90d', value: '-90d' },
        { label: 'filter.preset.last1y', value: '-1y' },
      ],
    },
  },
  examples: [
    { q: 'Yanick', desc: 'filter.example.findDriverYanick' },
    { q: 'category:"DD2" season:2026', desc: 'filter.example.activeDd22026' },
    { q: 'from:-90d', desc: 'filter.example.driversLast90d' },
  ],
});

